import React from 'react';
import { ArrowRightIcon } from '@heroicons/react/outline';
import site from '../../site.json';

// Shared resource cards for refreshed boards. `items`: [{ img, title, text, href }] from the board.
export default function ModernResources({ items }) {
  return (
  <section aria-labelledby="resources" className="bg-tint py-20 text-gray-600">
    <div className="mx-auto max-w-6xl px-5">
      <div className="text-center">
        <h2 id="resources" className="font-display text-3xl font-bold text-gray-900">
          Help for your next step
        </h2>
        <p className="mt-2 text-gray-600">{(site.home || {}).resourcesIntro}</p>
      </div>
      <div className="mt-12 grid gap-6 md:grid-cols-3">
        {items.map((r) => (
          <a
            key={r.title}
            href={r.href}
            rel="noreferrer"
            target="_blank"
            className="group flex flex-col overflow-hidden rounded-3xl bg-white shadow-sm ring-1 ring-primary/20 transition hover:-translate-y-1 hover:shadow-lg"
          >
            <div className="h-48 overflow-hidden bg-tint">
              <img alt="" className="h-full w-full object-cover object-center" src={r.img} />
            </div>
            <div className="flex flex-1 flex-col p-6">
              <h3 className="text-lg font-semibold text-gray-900">{r.title}</h3>
              <p className="mt-2 flex-1 text-sm leading-relaxed">{r.text}</p>
              <span className="mt-4 inline-flex items-center gap-1 text-sm font-semibold text-primary-dark">
                Learn more <ArrowRightIcon className="h-4 w-4 transition group-hover:translate-x-1" aria-hidden="true" />
              </span>
            </div>
          </a>
        ))}
      </div>
    </div>
  </section>
  );
}
